import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Od Angularu 21 je výchozí zoneless. Aplikace stojí na zone.js (ruční markForCheck,
// ng-zorro, RxJS v šablonách), proto zóny zapíná výslovně (EL-2338).
platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
})
  .catch(err => console.error(err));
